import { useLocation } from 'react-router';

import { itemByLanguage } from '@/utils/language';

import Constants from '@/constants';

import { DocumentProxyState } from '@/routes/TrainingPlans/MyPlans/DocumentProxy';

export const useIsTridionTraining = () => {
  const location = useLocation();

  const state = location.state as
    | (DocumentProxyState & { planName?: string })
    | undefined;

  const references = state?.step?.reference?.references;
  const resourceReferences = state?.step?.resource?.references;

  const docProxy = Array.isArray(resourceReferences)
    ? resourceReferences[0]
    : itemByLanguage(references);

  return {
    docProxy,
    isTridion:
      docProxy?.sourceSystem.toLowerCase() ===
      Constants.DOCUMENT_TYPES.TRIDION.toLowerCase(),
    planName: state?.planName,
    planId: state?.planId,
    isTrainingMode: !!state?.userIds,
  };
};
